import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton: React.FC = () => {
  const navigate = useNavigate();
  // const location = useLocation();

  const handleBack = () => {
    // Define the navigation flow based on current route
    // const routeMap: { [key: string]: string } = {
    //   '/pick-up': '/',
    //   '/upload-weight-ticket': '/pick-up',
    //   '/jobsite': '/upload-weight-ticket',
    //   '/proof-of-dump-meterial': '/upload-weight-ticket',
    //   '/dump-site-photo-reason': '/proof-of-dump-meterial',
    //   '/digital-signature': '/proof-of-dump-meterial',
    //   '/complete-delivery': '/digital-signature',
    // };

    // Get the previous route from the map
    // const previousRoute = routeMap[location.pathname];
    
    // if (previousRoute) {
    //   // Navigate to the previous step explicitly
    //   navigate(previousRoute);
    // } else {
      // Fallback to browser history if route not in map
      navigate(-1);
    // }
  };

  return (
    <button onClick={handleBack} className="back_btn">
      <i className="bi bi-arrow-return-left"></i>
        Back
    </button>
  );
};

export default BackButton;
